import type { I18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import Time from '@rover/icons/svg/time.svg';
import type { ThemeTextColor } from '@rover/kibble/styles/themeTypes';
import { EngagementSignal } from '@rover/rsdk/src/apiClient/latest/model/engagementSignal';
import type { SvgIcon } from '@rover/types/src/SvgIcon';

type EngagementSignalId = 'highly_responsive';

type EngagementSignalContent = {
  fullText: string;
  icon: SvgIcon;
  color: ThemeTextColor;
};

const ENGAGEMENT_SIGNAL_CONTENT_ENUM = (
  i18n: I18n
): Record<EngagementSignalId, EngagementSignalContent> => ({
  highly_responsive: {
    fullText: i18n._(msg`<0>Highly</0> responsive`),
    icon: Time,
    color: 'success',
  },
});

export const getEngagementSignalContent = (
  i18n: I18n,
  engagementSignal: EngagementSignal | null | undefined
): EngagementSignalContent | undefined => {
  if (!engagementSignal?.id) {
    return undefined;
  }

  return ENGAGEMENT_SIGNAL_CONTENT_ENUM(i18n)[engagementSignal.id];
};
